<template>
  <div>
    <Breadcrumbs main="Admin" title="Reviewers" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">


            <div class="card-body">
              <b-row>
                <b-col xl="6">
                  <div class="d-flex flex-column flex-xl-row " style="gap: 10px;">
                    <b-input-group class="datatable-btn">
                      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>

                  </div>

                </b-col>

                <b-col xl="6">
                  <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <div v-if="!loading && !error">
                <div class="table-responsive datatable-vue">
                  <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :per-page="perPage" @filtered="onFiltered">
                    <template #cell(index)="data">
                      {{ (currentPage - 1) * perPage + data.index + 1 }}
                    </template>

                    <template #cell(group)="row">
                        <div v-if="row.item.group !== null && row.item.group.length > 0">
                          <div v-for="group in row.item.group" :key="group.group_id">
                             <b-badge variant="success"  @click="deleteGroupFromReviewer(group.group_id, row.item.id)" >
                               <h7>{{ group.group__name}}</h7>
                               <b-icon icon="x"></b-icon>
                             </b-badge>


                          </div>
                        </div>
                        <div v-b-modal.modal-prevent-closing-label @click="addGroupToReviewer(row.item)">
                          <b-badge pill variant="secondary">Add Group</b-badge>
                        </div>
                    </template>

                    <template #cell(team_name)="row">

                      <router-link :to="`/admin/submission-detail/${row.item.id}`" class="link-style">
                        {{ row.value }}
                      </router-link>
                    </template>
                    <template #cell(updated)="row">
                      {{row.value.split('T')[0]}}
                    </template>



                    
                  </b-table>
                </div>
              </div>

              <b-col md="6" class="my-1 p-0">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
              </b-col>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
      <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this Fellowship?</div>
    </b-modal>

    <b-modal id="modal-prevent-closing-label" ref="modal" title="Add Group" @show="resetLabelModal"  @ok="handleOk">

      <div class="form-group">
        <label class="col-form-label">Group</label>
        <div style="position: relative; width: 100%;">
          <select class="form-control" v-model="submit_data.group">
            <option v-for="option in groups" :key="option.id" :value="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>

    </b-modal>

  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import 'sweetalert2/src/sweetalert2.scss';

  import {
    host
  } from '../../_helpers/APIPath';
  export default {

    data() {
      return {
        host: host,
        submit_data:{
          user:null,
          group:null,
        },
        tablefields: [{
                        key: 'index',
                        label: '#'
                      },

                      {
                        key: 'full_name',
                        label: 'Name',
                        sortable: true
                      },
                      {
                        key: 'email',
                        label: 'Email',
                        sortable: true
                      },{
                        key: 'group',
                        label: 'Group',
                        sortable: true
                      },

        ],

        filter: null,
        delete_value: null,

        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15]
      };
    },

    computed: {
    ...mapState({
      items: state => state.manage_user.reviewers,
      groups: state => state.manage_user.group,
      loading: state => state.manage_user.participantLoading,
      error: state => state.manage_user.participantError,
    }),

    sortOptions() {
      return this.tablefields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            };
          });
    }
    },

    watch: {

    },

    mounted() {

      this.$store.dispatch('manage_user/fetchReviewerList').then(() => {
        this.totalRows = this.items;

      });
      this.$store.dispatch('manage_user/fetchGroupList').then(() => {

      });

    },

    methods: {

      truncateText(text, maxLength) {
        if (text.length > maxLength) {
          return text.substring(0, maxLength) + '...';
        } else {
          return text;
        }
      },

      resetModal() {
        this.selectedStatus = '';
      },

      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      addGroupToReviewer(item){
        this.submit_data.user=item.id;
      },
      deleteGroupFromReviewer(group_id, user_id) {
        let payload={
          group: group_id,
          user: user_id,
        }
        console.log(payload);
        this.$store.dispatch("manage_user/removeReviewerFromGroup", payload).then(response => {
          if (response.code == 200) {
            Swal.fire({
              title: "Success!",
              text: response.response,
              icon: "success"
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: response.response,
              icon: "error"
            });
          }
        })
      },
      handleOk() {

        console.log(this.submit_data);
        this.$store.dispatch("manage_user/addReviewerToGroup", this.submit_data).then(response => {
          if (response.code == 201) {
            Swal.fire({
              title: "Success!",
              text: response.response,
              icon: "success"
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: response.response,
              icon: "error"
            });
          }
        })
      },

      updatefellowshipStatus(id){
        this.$store.dispatch('fellowship/updateStatusToggle', {
          fellowship_id: id,
        }).then(response => {
          if (response.status == 200) {
            Swal.fire({
              title: 'Success!',
              text: response.response,
              icon: 'success'
            });

            this.delete_value = null;

          } else {
            Swal.fire({
              title: 'Error!',
              text: response.response,
              icon: 'error'
            });
          }
        });
      }

    }
  };
</script>

<style scoped>
.header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
badge-style {
  display: flex;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
  background-color: #2c323f;
  padding: 0.375rem 1.75rem;
  color: white;
}


@media screen and (max-width: 460px) {
  .header-mobile {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
}
</style>
